(function () {
  'use strict';

  angular.module('sempraWebapp').component('siteDetails', {
    templateUrl: 'app/workingSchedulesAndHolidays/siteDetails/siteDetails.html',
    controller: siteDetails,
    bindings: {
      siteId: '<',
      refresh: '&'
    },
    controllerAs: 'vm'
  });

  function siteDetails(
    workingSchedulesActions,
    hostProtocol,
    hostDomain,
    Upload,
    $log,
    $scope,
    $mdToast,
    $translate
  ) {
    var vm = this;

    vm.$onInit = function () {};
    vm.$onChanges = function (changes) {
      if (changes.siteId.currentValue) {
        vm.imageLink =
          hostProtocol +
          '://' +
          hostDomain +
          '/api/washFacilities/' +
          changes.siteId.currentValue +
          '/image';
        workingSchedulesActions
          .getSiteDetailsById(changes.siteId.currentValue)
          .then(function (response) {
            vm.companyId = response.companyId;
            vm.name = response.name;
            vm.siteLocationLat = response.location.latitude;
            vm.siteLocationLong = response.location.longitude;
            vm.siteAddress = response.address;
            vm.sitePhone1 = response.phone1;
            vm.sitePhone2 = response.phone2;
            vm.siteWebsite = response.website;
            vm.hasChanger = response.changerAvailable;
            vm.offlineAlarmsStatus = response.offlineDeviceAlarmsDisabled;
            vm.siteDescription = response.info;
            vm.siteWorkingHours = response.workingHours;
          });
      } else if (changes.siteId.currentValue === '') {
        vm.companyId = null;
        vm.name = '';
        vm.siteLocationLat = '';
        vm.siteLocationLong = '';
        vm.siteAddress = '';
        vm.sitePhone1 = '';
        vm.sitePhone2 = '';
        vm.siteWebsite = '';
        vm.hasChanger = false;
        vm.offlineAlarmsStatus = false;
        vm.siteDescription = '';
        vm.siteWorkingHours = '';
        vm.imageLink = '/assets/images/noun_59149_cc.svg';
        vm.file = null;
      }
    };

    vm.siteSaveDetails = function () {
      workingSchedulesActions
        .updateSiteDetails(vm.siteId, {
          pointId: vm.siteId,
          location: {
            latitude: vm.siteLocationLat,
            longitude: vm.siteLocationLong
          },
          address: vm.siteAddress,
          phone1: vm.sitePhone1,
          website: vm.siteWebsite,
          info: vm.siteDescription
        })
        .then(function () {});
    };

    vm.submitImage = function () {
      if (vm.file) {
        uploadImage(vm.file);
      }
    };

    function uploadImage(file) {
      Upload.upload({
        url:
          hostProtocol +
          '://' +
          hostDomain +
          '/api/washFacilities/' +
          vm.siteId +
          '/image',
        data: { file: file }
      }).then(
        function (resp) {
          $log.info(
            'Success ' +
              resp.config.data.file.name +
              'uploaded. Response: ' +
              resp.data
          );
          vm.file = null;

          $mdToast.show(
            $mdToast
              .simple()
              .textContent(
                $translate.instant('FACILITY_UPLOAD_IMAGE_NOTIFICATION')
              )
              .position('bottom right')
              .hideDelay(3000)
          );
        },
        function (resp) {
          $log.info('Error status: ' + resp.status);
        },
        function (evt) {
          var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
          $log.info(
            'progress: ' + progressPercentage + '% ' + evt.config.data.file.name
          );
        }
      );
    }
  }
})();
